import { createApp } from 'vue';
import Team from './vue/team.vue';

const baseUrl = window.location.origin;
const app = createApp(Team, { apiBaseUrl: baseUrl });

app.mount('#team-root');
